module.exports = __webpack_public_path__ + "img/boss-bg.314eaf43.png";